export default "/app/global-wrapper-client/static/a88d44804f7caf05545ca039a1948753.woff2";